import script from "./loading_overlay.vue?vue&type=script&setup=true&lang=js"
export * from "./loading_overlay.vue?vue&type=script&setup=true&lang=js"

import "./loading_overlay.vue?vue&type=style&index=0&id=80fda1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80fda1e0"]])

export default __exports__